<template>
  <div class="my_collection">
    <div class="tit">
      <span>我的收藏</span>
    </div>
    <div class="body_content">
      <ul class="tab_list" v-if="CollectionType.length">
        <li v-for="item in CollectionType" :key="item.id">
          <router-link :class="{active:$route.path.indexOf(item.code) > -1}" :to="`/personal_center/park_user/my_collection/my_collection_${item.code}`"> {{item.name}}</router-link>
        </li>
      </ul>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import myTable from "@/components/my_table.vue";
export default {
  components: {
    myTable,
  },
  data() {
    return {
      CollectionType: [], //收藏类型
      tableObj: {
        tableName: "kyyq",
        list: [], //列表数据
        btns: [
          //按钮组
          {
            name: "查看详情",
            funcName: "seeDetail"
          },
          {
            name: "取消收藏",
            funcName: "cancelColl"
          }
        ],
        table_detail: [
          //table详情
          {
            prop: "classs_l_name",
            label: "仪器类型",
            width: "100px"
          },
          {
            // prop: "address",
            label: "所在地",
            width: "200px",
            formatter: row => {
              return row.province_name + row.city_name + row.county_name;
            }
          },
          {
            prop: "country",
            label: "生产国",
            width: "80px"
          },
          {
            prop: "institute_name",
            label: "所属机构"
          }
        ],
        layerpageinfo: {
          //分页
          pageNo: 0,
          total: 10,
          pageSize: 10
        }
      }
    };
  },
  created() {
    this.getDictionaries("CollectionType").then(res => {
      //获取收藏类型
      let list = res;
      this.CollectionType = list.slice(0,5);
      list.forEach(item => {
        if (this.$route.path.indexOf(item.code) > -1) {
          this.activeName2 === item.code;
        }
      });
    });
  },
  mounted() {},
  methods: {
    /**获取对应类型字典封装
     * @params type 字典类型
     * */
    getDictionaries(type) {
      let obj = {
        typeCode: type,
        pageNo: 0,
        pageSize: 999
      };
      return new Promise(resolve => {
        this.api.getDictionaries(obj).then(res => {
          if (res.error.err_code !== 0) return;
          let list = res.obj.list || [];
          list = list.length ? list : null;
          resolve(list);
        });
      });
    },
  }
};
</script>

<style lang="scss">
@import "../../index.scss";

.my_collection {
  .tab_list{
    display: flex;
    padding: 0 0 10px;
    border-bottom:1px solid $bd-color;
    li{
      display: flex;
       padding: 0 20px;
      a{
        height: 40px;
        line-height: 40px;
        color: $font-gary;
        border-bottom: 2px solid transparent;
      }
      a.active{
        color: $font-blue;
        border-bottom: 2px solid $font-blue;
      }
    }
  }
}
</style>
